import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRouter from './app/AppRouter';
import { AuthProvider } from './app/components/auth';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <AuthProvider>
    <AppRouter />
  </AuthProvider>
);
